/* eslint-disable camelcase */
import FrameworkUtils from 'utils/framework';
import Message from 'ai/components/SuperChat/Messages/Message/Message';
import { Flex } from 'components/ui';
import FeedbackCollection from 'ai/components/SuperChat/FeedbackCollection';
import LoadingDots from 'ai/components/SuperChat/LoadingDots/LoadingDots';
import { RESPONSE_TYPES, ENTRYPOINTS } from 'ai/constants/superchat';
import ProductRecommendation from 'ai/components/SuperChat/ProductRecommendation';
import ContextualDivider from 'ai/components/SuperChat/ContextualDivider/ContextualDivider';

const { wrapFunctionalComponent } = FrameworkUtils;

function Messages(props) {
    const {
        messages, isLoading, feedbackSteps, sessionId, submitFeedback, onCloseFeedback
    } = props;

    if (!messages.length && !isLoading) {
        return null;
    }

    return (
        <Flex
            gap={5}
            flexDirection='column'
            width='100%'
        >
            {messages.map((message, index) => {
                if (message.response_type === RESPONSE_TYPES.CONTEXTUAL_DIVIDER) {
                    const {
                        entrypoint, category, products, search_term
                    } = message.data;

                    if (entrypoint === ENTRYPOINTS.PDP && products && products.length > 0) {
                        const product = products[0];
                        const brandName = product?.brand_name;
                        const title = product?.title;

                        let label = '';

                        if (brandName && title) {
                            label = `${brandName} - ${title}`;
                        } else if (brandName) {
                            label = brandName;
                        } else if (title) {
                            label = title;
                        }

                        if (label) {
                            return (
                                <ContextualDivider
                                    key={`divider-${message.session_id}-${index}`}
                                    label={label}
                                />
                            );
                        }
                    }

                    if (entrypoint === ENTRYPOINTS.SRP && search_term) {
                        return (
                            <ContextualDivider
                                key={`divider-${message.session_id}-${index}`}
                                label={search_term}
                            />
                        );
                    }

                    if (category && category?.name) {
                        return (
                            <ContextualDivider
                                key={`divider-${message.session_id}-${index}`}
                                label={category.name}
                                categoryId={category.category_id}
                            />
                        );
                    }

                    return null;
                }

                if (message.response_type === RESPONSE_TYPES.FEEDBACK_COLLECTION) {
                    return (
                        <FeedbackCollection
                            key='feedback-collection'
                            feedbackSteps={feedbackSteps}
                            sessionId={sessionId}
                            submitFeedback={submitFeedback}
                            onClose={onCloseFeedback}
                        />
                    );
                }

                if (message.response_type === RESPONSE_TYPES.PRODUCT_RECOMMENDATION_RESPONSE) {
                    return (
                        <ProductRecommendation
                            key={index}
                            products={message?.data?.products || []}
                        />
                    );
                }

                return (
                    <Message
                        key={index}
                        message={message}
                    />
                );
            })}

            {/* Show loading dots when waiting for response */}
            {isLoading && <LoadingDots />}
        </Flex>
    );
}

// const styles = {};

export default wrapFunctionalComponent(Messages, 'Messages');
